export const isNewInquiryNotification = notification =>
  ['NEW_INQUIRY', 'AUTO_CLAIM_INQUIRY'].includes(notification?.notificationKind)

// WebSocket 与轮询使用同一个询价事件键；重新投递时 timestamp 变化也不重复弹窗。
export function createInquiryNotificationTracker() {
  const displayed = new Map()
  const knownCandidates = new Set()
  let initialized = false
  const remember = id => {
    knownCandidates.add(id)
    if (knownCandidates.size > 2048) knownCandidates.delete(knownCandidates.values().next().value)
  }
  return {
    accept(notification, userId, now = Date.now()) {
      if (!notification || typeof notification !== 'object' || Array.isArray(notification) || !userId) return false
      if (notification.targetUserId != null && String(notification.targetUserId) !== String(userId)) return false
      // 自动认领通知必须明确接收人，不接收缺少目标的广播消息。
      if (notification.notificationKind === 'AUTO_CLAIM_INQUIRY'
          && (notification.targetUserId == null || !notification.inquiryId)) return false
      const newInquiry = isNewInquiryNotification(notification) && notification.inquiryId
      const key = newInquiry
        ? `INQUIRY:${notification.inquiryId}:${userId}`
        : [notification.notificationKind, notification.inquiryId, userId, notification.timestamp].join(':')
      for (const [entry, time] of displayed) if (now - time > 24 * 60 * 60 * 1000) displayed.delete(entry)
      if (displayed.has(key)) return false
      displayed.set(key, now)
      if (displayed.size > 2048) displayed.delete(displayed.keys().next().value)
      if (newInquiry) remember(String(notification.inquiryId))
      return true
    },
    observeCandidates(rows, userId) {
      if (!Array.isArray(rows) || !userId) return []
      const notifications = []
      for (const row of rows) {
        if (!row?.id || (row.kfClaimUserId != null && String(row.kfClaimUserId) !== String(userId))) continue
        const id = String(row.id)
        if (initialized && !knownCandidates.has(id)) {
          notifications.push({
            notificationKind: 'NEW_INQUIRY', inquiryId: id, targetUserId: String(userId),
            title: '收到新询价', targetPath: '/kefu/shedit',
            // 轮询只能证实当前已认领，不能把人工认领或转交误报为自动认领。
            content: row.kfClaimUserId == null ? `询价 ${id} 待认领审核` : `询价 ${id} 已由您认领，请及时审核。`
          })
        }
        remember(id)
      }
      initialized = true
      return notifications.reverse()
    },
    reset() { displayed.clear(); knownCandidates.clear(); initialized = false }
  }
}
